import { Button, Modal, TextInput, Textarea } from '@mantine/core';
import React, { useState } from 'react';

interface FreeDeliveryModalProps {
    opened: boolean;
    onClose: () => void;
    orderId: string;
    productDetails: string;
    onSubmit: (data: { orderId: string; recipientName: string; recipientAddress: string; recipientPhone: string; productDetails: string }) => void;
}

const FreeDeliveryModal: React.FC<FreeDeliveryModalProps> = ({ opened, onClose, orderId, productDetails, onSubmit }) => {
    const [recipientName, setRecipientName] = useState('');
    const [recipientAddress, setRecipientAddress] = useState('');
    const [recipientPhone, setRecipientPhone] = useState('');
    const [submitting, setSubmitting] = useState(false);

    const handleSubmit = async () => {
        setSubmitting(true);
        await onSubmit({ orderId, recipientName, recipientAddress, recipientPhone, productDetails });
        setSubmitting(false);
        onClose();
    };

    return (
        <Modal opened={opened} onClose={onClose} title="Free Delivery Details" centered>
            <TextInput
                label="Recipient Name"
                value={recipientName}
                onChange={e => setRecipientName(e.currentTarget.value)}
                required
                mb="md"
            />
            <Textarea
                label="Recipient Address"
                value={recipientAddress}
                onChange={e => setRecipientAddress(e.currentTarget.value)}
                required
                mb="md"
            />
            <TextInput
                label="Recipient Phone Number"
                value={recipientPhone}
                onChange={e => setRecipientPhone(e.currentTarget.value)}
                required
                mb="md"
            />
            <Button fullWidth onClick={handleSubmit} loading={submitting} mt="md" color="blue">
                Submit Details
            </Button>
        </Modal>
    );
};

export default FreeDeliveryModal;